<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Login form</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="username"
                label="Username"
                name="username"
                prepend-icon="mdi-account"
                type="text"
                :rules="usernameRules"
                required
              />

              <v-text-field
                v-model="password"
                id="password"
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                :rules="passwordRules"
                required
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="login">Login</v-btn>
          </v-card-actions>
        </v-card>

        <v-alert
          v-model="needToShowError"
          class="validation-error"
          dark
          text
          prominent
          type="error"
          icon="mdi-cloud-alert"
          close-text="Close"
          dismissible
          >{{ serverError }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    valid: true,
    username: null,
    usernameRules: [
      (v) => !!v || "Username is required",
      (v) => (v && v.length > 2) || "Username must be more than 4 characters",
    ],
    password: null,
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => (v && v.length > 4) || "Password must be more than 4 characters",
    ],
  }),
  computed: {
    needToShowError: {
      get() {
        return !!this.serverError;
      },
      set() {
        this.touch();
      },
    },
    serverError() {
      return this.$store.getters.authServerError;
    },
  },
  methods: {
    login() {
      if (!this.needToShowError && this.$refs.form.validate()) {
        const { username, password } = this;
        this.$store
          .dispatch("app/authRequest", { username, password })
          .then(() => {
            sessionStorage.clear();
            this.$router.push("/");
          })
          .catch(() => (this.valid = false));
      }
    },
    touch() {
      if (this.serverError) {
        this.$store.dispatch("app/authCleanError");
      }
    },
  },
  created() {
    this.$watch(
      () => String(this.password).length + String(this.username).length,
      this.touch.bind(this)
    );
  },
};
</script>
<style lang="scss" scoped>
.validation-error {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, -50%);
}
</style>
